// Explicit ArrowUp/ArrowDown handlers — @dnd-kit's KeyboardSensor only fires after Space/Enter activation.

import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconSize} from '@Components/icon-v2/icon.types';
import type {FieldDragHandleProps} from './field-drag-handle.types';
import styles from './field-drag-handle.module.scss';

export function FieldDragHandle({attributes, listeners, setActivatorNodeRef, label, onMoveUp, onMoveDown, isFirstMovable, isLastMovable}: FieldDragHandleProps): ReactElement {
  const dndOnKeyDown = listeners?.onKeyDown;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>): void => {
    dndOnKeyDown?.(event);
    if (event.defaultPrevented) {
      return;
    }
    if (event.key === 'ArrowUp' && !isFirstMovable) {
      event.preventDefault();
      onMoveUp();
    } else if (event.key === 'ArrowDown' && !isLastMovable) {
      event.preventDefault();
      onMoveDown();
    }
  };

  return (
    <button
      type="button"
      ref={setActivatorNodeRef}
      className={styles.dragHandle}
      aria-label={`${window.i18next.t('pmwjs_form_maker_drag_to_reorder_field')}: ${label}`}
      {...attributes}
      {...(listeners ?? {})}
      onKeyDown={handleKeyDown}
    >
      <Icon icon="icon-draggable" size={IconSize.SIZE_ICON_16} className={styles.dragHandleIcon} />
    </button>
  );
}
